// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

type UserMessageType = {
  chatMessage: string;
};

const UserMessage = ({ chatMessage }: UserMessageType) => {
  return (
    <Grid
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "16px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#202338",
          color: "#FFF",
          borderRadius: "8px 8px 0px 8px",
          padding: "12px",
          width: "fit-content",
        }}
      >
        {chatMessage}
      </Box>
    </Grid>
  );
};

export default UserMessage;
